module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319037.bf79cc98.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319037.pdf
// module id = 830
// module chunks = 0